import React from "react";

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles(theme => {
	const t = getTokens(theme.palette.type, theme.palette.primary.main);
	return {
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
		},
		// quadradinho de superfície: o indicador fica legível sobre qualquer tela, claro ou escuro
		box: {
			width: 56,
			height: 56,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			backgroundColor: t.paper,
			border: `1px solid ${t.line}`,
			borderRadius: t.radius.md,
			boxShadow: t.shadow.lift,
			color: t.brand,
		},
	};
});

const BackdropLoading = () => {
	const classes = useStyles();
	return (
		<Backdrop className={classes.backdrop} open={true}>
			<div className={classes.box}>
				<CircularProgress color="inherit" size={26} />
			</div>
		</Backdrop>
	);
};

export default BackdropLoading;
